import * as React from 'react';

export type OnMouseEnterContextType =
  | ((e: React.MouseEvent<HTMLElement>) => void)
  | undefined;

export const onMouseEnterContext = React.createContext<OnMouseEnterContextType>(undefined);
